import { formatTimeToShortAMPM } from '@/utils';
import style from './NoteInfo.module.scss';
import { useAppSelector } from '@ax/redux-store';

const NoteInfo = () => {
  const visitsState = useAppSelector((state) => state.selectedVisit);
  const formattedAppointmentStartTime = visitsState.appointmentStartTime
    ? formatTimeToShortAMPM(visitsState.appointmentStartTime)
    : '';

  const patientName = [visitsState.patientLastName, visitsState.patientFirstName]
    .filter(Boolean)
    .join(', ');

  return (
    <>
      <div className={style.container}>
        <span>{formattedAppointmentStartTime}</span>
        <span>{patientName}</span>
      </div>
    </>
  );
};

export default NoteInfo;
